
import React from 'react'
import { ChatPlatform } from 'lib/twitchChatParse'

export const PLATFORM_MARK_HEIGHT_PX = 18

export const PLATFORM_MARK_STYLE: React.CSSProperties = Object.freeze({
  display: 'inline-block',
  width: 'auto',
  height: PLATFORM_MARK_HEIGHT_PX,
  marginRight: 4,
  verticalAlign: 'middle',
  filter: 'none',
  opacity: 1,
  transform: 'none',
  mixBlendMode: 'normal'
})

export const YOUTUBE_MARK_SRC = '/images/yt_icon_red_digital.png'
export const TWITCH_MARK_SRC = '/images/glitch_flat_purple.png'

export const PLATFORM_MARKS: Record<ChatPlatform, { src: string, label: string }> = Object.freeze({
  TWITCH: { src: TWITCH_MARK_SRC, label: 'Twitch' },
  YOUTUBE: { src: YOUTUBE_MARK_SRC, label: 'YouTube' }
})
